import builder from '../builder';
import OfficeFileXLS1 from '../../streamline-icons/bold/office-file-xls-1.svg';

export default builder('OfficeFileXLS1Bold', OfficeFileXLS1);
